/**
 * Read a File into a base64 data URL (e.g. "data:image/png;base64,...").
 * Used by the lineup screenshot upload flows before sending the image to the
 * extract-lineup edge function.
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error ?? new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}
